import type { RouteObject } from 'react-router'

import { routeCrumb } from '../client/components/Admin/TopNavBar/utils/routeCrumb.js'

export const billingRoutes: RouteObject = {
  path: 'billing',
  async lazy() {
    const { BillingBreadCrumb } = await import(
      '../client/components/Admin/Billing/BillingPage/BillingRoute.js'
    )
    const { RouteContainer } = await import(
      '../client/components/Container/RouteContainer.js'
    )

    return {
      Component: RouteContainer,
      handle: routeCrumb(BillingBreadCrumb),
    }
  },
  children: [
    {
      index: true,
      async lazy() {
        const { BillingPage, BillingSummaryBreadCrumb } = await import(
          '../client/components/Admin/Billing/BillingPage/index.js'
        )

        return {
          Component: BillingPage,
          handle: routeCrumb(BillingSummaryBreadCrumb),
        }
      },
    },
    {
      path: 'plans',
      async lazy() {
        const { PlansPage, BillingPlansBreadCrumb } = await import(
          '../client/components/Admin/Billing/PlansPage/index.js'
        )

        return {
          Component: PlansPage,
          handle: routeCrumb(BillingPlansBreadCrumb),
        }
      },
    },
    {
      path: 'usages',
      async lazy() {
        const { UsagesPage, BillingUsagesBreadCrumb } = await import(
          '../client/components/Admin/Billing/UsagesPage/index.js'
        )

        return {
          Component: UsagesPage,
          handle: routeCrumb(BillingUsagesBreadCrumb),
        }
      },
    },
  ],
}
